import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=049b1133&scoped=true"
import script from "./ToolbarButton.vue?vue&type=script&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&lang=js"
import style0 from "./ToolbarButton.vue?vue&type=style&index=0&id=049b1133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b1133",
  null
  
)

export default component.exports